import React from 'react';
import InputController from '@/components/inputController';
import { PERSONAL_DATA } from '@/constants/personalData';
import FormTemplate from '@/components/formTemplate';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';

function PersonalData({ control, showTitle = true }) {
  const {
    TITLE,
    ID,
    DOC_NUMBER,
    CIF,
    COMPANY_NAME,
    FULL_NAME,
    EMAIL,
    CONTACT_PHONE,
  } = PERSONAL_DATA;
  return (
    <div className="personal-data-container">
      <FormTemplate titleText={showTitle ? TITLE : ''} cyData={ID}>
        <InputController
          className="personal-data-container__input"
          inputName={CIF.NAME}
          inputId={CIF.ID}
          control={control}
          rules={{
            required: CIF.RULES.REQUIRED,
            pattern: CIF.RULES.PATTERN.CIF_FORMAT,
          }}
          label={CIF.LABEL}
        />
        <InputController
          className="personal-data-container__input"
          inputName={COMPANY_NAME.NAME}
          inputId={COMPANY_NAME.ID}
          control={control}
          rules={{
            required: COMPANY_NAME.RULES.REQUIRED,
            pattern: COMPANY_NAME.RULES.PATTERN.COMPANY_NAME,
            validate: (fieldValue) =>
              COMPANY_NAME.RULES.VALIDATE.EMPTY_TEXT.checkFunc(fieldValue) ||
              COMPANY_NAME.RULES.VALIDATE.EMPTY_TEXT.message,
          }}
          label={COMPANY_NAME.LABEL}
        />
        <InputController
          className="personal-data-container__input"
          inputName={EMAIL.NAME}
          inputId={EMAIL.ID}
          control={control}
          rules={{
            required: EMAIL.RULES.REQUIRED,
            pattern: EMAIL.RULES.PATTERN.EMAIL_FORMAT,
            validate: (fieldValue) =>
              EMAIL.RULES.VALIDATE.EMAIL_DOMAIN.checkFunc(fieldValue) ||
              EMAIL.RULES.VALIDATE.EMAIL_DOMAIN.message,
          }}
          label={EMAIL.LABEL}
        />
        <InputController
          className="personal-data-container__input"
          inputId={CONTACT_PHONE.ID}
          inputName={CONTACT_PHONE.NAME}
          mask={CONTACT_PHONE.MASK}
          control={control}
          rules={{
            required: CONTACT_PHONE.RULES.REQUIRED,
            validate: (fieldValue) =>
              CONTACT_PHONE.RULES.VALIDATE.CONTACT_PHONE_FORMAT.checkFunc(
                fieldValue
              ) || CONTACT_PHONE.RULES.VALIDATE.CONTACT_PHONE_FORMAT.message,
          }}
          label={CONTACT_PHONE.LABEL}
          info={CONTACT_PHONE.INFO}
        />
        <InputController
          className="personal-data-container__input"
          inputId={DOC_NUMBER.ID}
          inputName={DOC_NUMBER.NAME}
          control={control}
          rules={{
            required: DOC_NUMBER.RULES.REQUIRED,
            pattern: DOC_NUMBER.RULES.PATTERN.DOC_NUMBER_FORMAT,
            validate: (fieldValue) =>
              DOC_NUMBER.RULES.VALIDATE.DOC_NUMBER_FORMAT.checkFunc(
                fieldValue
              ) || DOC_NUMBER.RULES.VALIDATE.DOC_NUMBER_FORMAT.message,
          }}
          label={DOC_NUMBER.LABEL_AU}
        />
        <InputController
          className="personal-data-container__input"
          inputId={FULL_NAME.ID}
          inputName={FULL_NAME.NAME}
          control={control}
          rules={{
            required: FULL_NAME.RULES.REQUIRED,
            pattern: FULL_NAME.RULES.PATTERN.NAME_FORMAT,
            validate: (fieldValue) =>
              FULL_NAME.RULES.VALIDATE.EMPTY_TEXT.checkFunc(fieldValue) ||
              FULL_NAME.RULES.VALIDATE.EMPTY_TEXT.message,
          }}
          label={FULL_NAME.LABEL}
        />
        <Text
          text="Deberás presentar la documentación de acreditación de la empresa y representante legal en cualquier tienda Movistar."
          size={TEXT_SIZE.CAPTION2}
          color={TEXT_COLOR.GREY5}
          cyData={`${ID}__au_text`}
        />
      </FormTemplate>
      <style jsx>
        {`
          .personal-data-container {
            margin-bottom: 12px;
            :global(.personal-data-container__input) {
              margin: 0px 0 8px 0px;
              width: 100%;
            }
            :global(.personal-data-container__input--last) {
              margin: 0px 0 0px 0px;
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
}
export default PersonalData;
